export default function ComingSoon({ title }) {
  return (
    <div style={{ padding: '24px 28px' }}>
      <h4 style={{ fontWeight: 700, marginBottom: 16, color: 'var(--t1)' }}>{title}</h4>
      <div style={{
        background: 'var(--card)',
        borderRadius: 12,
        border: '1px solid #eef3f7',
        padding: '60px 24px',
        textAlign: 'center',
        color: 'var(--t3)',
        fontSize: 14,
      }}>
        Coming soon
      </div>
    </div>
  );
}
